import { fg } from '@confluence/feature-gating';

export const isMeetingRecorderEligibilityEnabled = (): boolean =>
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	fg('twcg-2202-loom-meeting-nudge-ht-gate') || fg('twcg-2202-loom-meeting-nudge-lt-gate');
